<template>
  <span>
    <a href="" @click.prevent.stop="showModal = true"
      class="badge"
      :class="[
        (item.type === 'User') ? 'badge-primary' : '',
        (!['GM','Player'].includes(item.type)) ? 'badge-default' : '',
        (size) ? size : ''
      ]">
      {{item.name}}
    </a>
    <ez-modal v-if="showModal" @close="showModal = false" size="m-small" :showGears="description === null">
      <h3>
        {{item.name}}
      </h3>
      <div class="text-left">
        <div v-html="$embers.markdown(description)" v-if="description"></div>
      </div>
    </ez-modal>
  </span>
</template>

<script>
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "vue-ez-badges",
  mixins: [modal],
  props: ["item", "size"],
  data() {
    return {
      description: null
    };
  },
  watch: {
    showModal: "getData"
  },
  methods: {
    async getData() {
      try {
        let res = await this.$http.get(
          `/${this.item._refType}/${this.item._refId}`
        );
        this.description = res.data.description;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.large {
  font-size: 0.875em;
}
</style>
